// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1veSO","item":"Tabs_item__1Ao9h","active":"Tabs_active__1BOwl"};